import { AlertCircle } from "lucide-react";
import { forwardRef, type TextareaHTMLAttributes, useId } from "react";

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
	label?: string;
	error?: string;
	hint?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
	({ label, error, hint, id, className = "", ...props }, ref) => {
		const generatedId = useId();
		const textareaId = id || generatedId;

		return (
			<div className="space-y-1.5">
				{label && (
					<label
						htmlFor={textareaId}
						className="block font-medium text-sm text-text-secondary"
					>
						{label}
					</label>
				)}

				<textarea
					ref={ref}
					id={textareaId}
					className={`min-h-[100px] w-full resize-y rounded-md border bg-bg-secondary px-3 font-sans text-sm text-text-primary transition-all duration-150 placeholder:text-text-tertiary focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent/50 disabled:cursor-not-allowed disabled:opacity-50 py-2.5${error ? "border-bug focus:border-bug focus:ring-bug/50" : "border-border hover:border-border-hover"}
						${className}
					`}
					{...props}
				/>

				{error ? (
					<p className="flex items-center gap-1 text-bug text-xs">
						<AlertCircle className="h-3.5 w-3.5" />
						{error}
					</p>
				) : hint ? (
					<p className="text-text-tertiary text-xs">{hint}</p>
				) : null}
			</div>
		);
	},
);

Textarea.displayName = "Textarea";
